import { render, staticRenderFns } from "./QuickQuoteTab.vue?vue&type=template&id=0944060c&lang=html&"
import script from "./QuickQuoteTab.vue?vue&type=script&lang=js&"
export * from "./QuickQuoteTab.vue?vue&type=script&lang=js&"
import style0 from "./QuickQuoteTab.vue?vue&type=style&index=0&id=0944060c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports